import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// A rounded conifer: a tapered-capsule trunk + stacked smooth lathe skirts
// (a slightly bellied conifer profile) instead of faceted cones. Sways (#4).
// Rounded art style, plan 28 stage 4.
// Geometry only — spawn metadata (weight/mapColor/habitat/sway/…) lives in
// content/decos/pine.json; this build is registered in src/model/coded.ts.
const build: (ctx: DecoBuildCtx) => void = ({ bone, lathe, seed }) => {
    const trunk = shade(0x6b4a2b, (rand(seed) - 0.5) * 0.2);
    const needle = shade(0x2c5a30, (rand(seed + 1) - 0.5) * 0.25);
    const h = 3 + rand(seed + 2) * 2;

    // trunk — tapered capsule, wider at the base (bottom cap sunk into grade)
    bone(0, 0.1, 0, 0, h * 0.4, 0, 0.28, 0.16, trunk);

    const tiers = 3 + Math.floor(rand(seed + 3) * 2);
    let y = h * 0.3;
    let r = 1.9;
    for (let i = 0; i < tiers; i++) {
      // a bellied conifer skirt: full radius at the base, tapering to a soft
      // point over 1.6 units (segs 8 keeps the low-poly toon read).
      lathe(0, y, 0, [[r, 0], [r * 0.45, 1.0], [0, 1.6]], shade(needle, i * 0.05), 1, 8);
      y += 0.9;
      r *= 0.74;
    }
  };

export default build;
